import { Dispatch } from 'react';
import { AxiosError, AxiosResponse } from 'axios';

import { api, ROUTES } from '../../../services/api';
import { BOT_ACTIONS } from './index';
import ERRORS from '../../../constants/errors.constants';
import { CreateBotResponse } from '../../../typings';
import { ReduxReducers } from '../../reducers';

const createBot = (
    name: string,
    hourlyLimitSup: number,
    hourlyLimitInf: number,
    secondsRetry: number,
    setup: string,
    typeBot: string,
    callback: (err: any, message?: string) => void,
) => {
    return async (dispatch: Dispatch<any>, getState: () => ReduxReducers) => {
        try {
            const { token } = getState().auth;
            const { bots } = getState().bots;

            dispatch({
                type: BOT_ACTIONS.CREATE_BOT,
            });

            const response = await api.post<CreateBotResponse, AxiosResponse<CreateBotResponse>>(
                ROUTES.BOT.CREATE, 
                { name, hourlyLimitSup, hourlyLimitInf, secondsRetry, setup, typeBot },
                {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                    },
                });

            if (response.data?.data && response?.data?.errors?.length === 0) {
                const { data: bot } = response?.data;

                dispatch({
                    type: BOT_ACTIONS.CREATE_BOT_SUCCESS,
                    payload: {
                        bots: [{
                            ...bot,
                        }].concat(bots),
                    },
                });
                
                return callback && callback(false, 'Bot cadastrado com sucesso!');
            }

            const ERROR_CODE = response.data?.errors[0];

            dispatch({
                type: BOT_ACTIONS.CREATE_BOT_FAILED,
            });
            
            return callback && callback(true, ERRORS[ERROR_CODE])
        } catch (error: any) {

            if (error.response) {
                const ERROR_CODE = (error as AxiosError<CreateBotResponse>).response?.data?.errors[0];
                dispatch({
                    type: BOT_ACTIONS.CREATE_BOT_FAILED,
                });
                return callback && callback(true, ERRORS[ERROR_CODE!]);
            }

            dispatch({
                type: BOT_ACTIONS.CREATE_BOT_FAILED,
            });
            return callback && callback(true, String(error));
        }
    }
}

export default createBot;